<template>
  <card-component>
    <div class="level">
      <div
        v-if="icon"
        class="level-item has-widget-icon"
      >
        <div class="is-widget-icon">
          <b-icon
            :icon="icon"
            size="is-large"
            :type="type"
          />
        </div>
      </div>
      <div class="level-item">
        <div class="is-widget-label">
          <h3 class="subtitle is-spaced">
            {{ label }}
          </h3>
          <h1 class="title">
            <growing-number
              :value="number"
              :prefix="prefix"
              :suffix="suffix"
            />
          </h1>
        </div>
      </div>
    </div>
  </card-component>
</template>

<script>
import { defineComponent } from '@vue/composition-api'
import CardComponent from '@/components/CardComponent.vue'
import GrowingNumber from '@/components/GrowingNumber.vue'

export default defineComponent({
  name: 'CardWidget',
  components: { GrowingNumber, CardComponent },
  props: {
    icon: {
      type: String,
      default: null
    },
    number: {
      type: Number,
      default: 0
    },
    prefix: {
      type: String,
      default: null
    },
    suffix: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: null
    }
  }
})
</script>
